// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3464fbb7","545":"ca0bc012","787":"cdb2b708"}[chunkId] + ".chunk.js";
};